export var LlmModelName;
(function (LlmModelName) {
    LlmModelName["amazon_nova_pro"] = "amazon.nova-pro-v1:0";
    LlmModelName["claude_3_5_haiku"] = "anthropic.claude-3-5-haiku-20241022-v1:0";
    LlmModelName["claude_3_5_sonnet_v2"] = "anthropic.claude-3-5-sonnet-20241022-v2:0";
    LlmModelName["claude_3_7_sonnet_v1"] = "anthropic.claude-3-7-sonnet-20250219-v1:0";
    LlmModelName["claude_opus_4"] = "anthropic.claude-opus-4";
    LlmModelName["claude_sonnet_4"] = "anthropic.claude-sonnet-4";
    LlmModelName["deepseek_r1"] = "deepseek-r1";
    LlmModelName["deepseek_v3"] = "deepseek-ai/DeepSeek-V3";
    LlmModelName["gemini_1_5_pro"] = "gemini-1.5-pro-002";
    LlmModelName["gemini_1_5_flash"] = "gemini-1.5-flash-002";
    LlmModelName["gemini_2_0_flash_001"] = "gemini-2.0-flash-001";
    LlmModelName["gemini_2_0_flash_lite"] = "gemini-2.0-flash-lite";
    LlmModelName["gemini_2_0_flash_thinking_exp_01_21"] = "gemini-2.0-flash-thinking-exp-01-21";
    LlmModelName["gemini_2_5_flash"] = "gemini-2.5-flash";
    LlmModelName["gemini_2_5_flash_lite"] = "gemini-2.5-flash-lite";
    LlmModelName["gemini_2_5_pro_preview_03_25"] = "gemini-2.5-pro-preview-03-25";
    LlmModelName["gemini_2_5_pro"] = "gemini-2.5-pro";
    LlmModelName["gemini_3_pro_preview"] = "gemini-3-pro-preview";
    LlmModelName["gemini_3_flash_preview"] = "gemini-3-flash-preview";
    LlmModelName["gemini_3_1_pro_preview"] = "gemini-3.1-pro-preview";
    LlmModelName["gemini_3_1_flash_lite_preview"] = "gemini-3.1-flash-lite-preview";
    LlmModelName["gpt_4_1"] = "gpt-4.1";
    LlmModelName["gpt_4_1_mini"] = "gpt-4.1-mini";
    LlmModelName["gpt_4_1_nano"] = "gpt-4.1-nano";
    LlmModelName["gpt_4o"] = "gpt-4o";
    LlmModelName["gpt_4o_mini"] = "gpt-4o-mini";
    LlmModelName["gpt_5"] = "gpt-5";
    LlmModelName["gpt_5_mini"] = "gpt-5-mini";
    LlmModelName["gpt_5_nano"] = "gpt-5-nano";
    LlmModelName["gpt_5_1"] = "gpt-5.1";
    LlmModelName["gpt_5_2"] = "gpt-5.2";
    LlmModelName["gpt_5_4"] = "gpt-5.4";
    LlmModelName["gpt_5_4_mini"] = "gpt-5.4-mini";
    LlmModelName["gpt_5_4_nano"] = "gpt-5.4-nano";
    LlmModelName["claude_opus_4_1"] = "anthropic.claude-opus-4-1-20250805-v1:0";
    LlmModelName["claude_opus_4_5"] = "anthropic.claude-opus-4-5-20251015-v1:0";
    LlmModelName["claude_haiku_4_5"] = "anthropic.claude-haiku-4-5-20251015-v1:0";
    LlmModelName["claude_sonnet_4_5"] = "anthropic.claude-sonnet-4-5-20250929-v1:0";
    LlmModelName["claude_opus_4_6"] = "anthropic.claude-opus-4-6-v1";
    LlmModelName["claude_sonnet_4_6"] = "anthropic.claude-sonnet-4-6";
    LlmModelName["meta_llama_3_2_11b"] = "meta.llama3-2-11b-instruct-v1:0";
    LlmModelName["meta_llama_3_3_70b"] = "meta.llama3-3-70b-instruct-v1:0";
    LlmModelName["o1"] = "o1";
    LlmModelName["o3"] = "o3";
    LlmModelName["o1_mini"] = "o1-mini";
    LlmModelName["o3_mini"] = "o3-mini";
    LlmModelName["o4_mini"] = "o4-mini";
    LlmModelName["notable_default"] = "notable-default";
})(LlmModelName || (LlmModelName = {}));
//# sourceMappingURL=modelName.js.map